<template>
  <CopyTaskModal/>
  <SelectMonthModal/>
  <button
    type="button"
    class="btn btn-primary btn-floating btn-lg"
    id="btn-back-to-top"
    ref="mybutton"
    @click="backToTop"
  >
    <i class="fas fa-arrow-up"></i>
  </button>
  <Navbar ref="navbar"/>
  <div>
    <div ref="toolbar" id="toolbar" class="d-flex text-darker justify-content-evenly sticky-top" style="top: 57px;">
      <div>
        <span role="button" class="text-secondary text-decoration-none d-flex justify-content-between">
          <span v-show="isSearchVisible" @click="init">Zamknij wyszukiwanie</span>
          <span v-show="!isSearchVisible" @click="isSearchVisible = true; toolbarHeightTop = 120; tableHeadingHeightTop = 172.5">Szukaj</span>
          <span role="button" v-show="!refreshing && isSearchVisible && visibleTasksCount > 0 && !showAllSearchResults && foundTasksCount > 25" class="text-success fw-bolder ms-3 text-decoration-underline" @click="showAllSearchResults = true">
            Pokazuję {{ visibleTasksCount }} wyników, pokaż więcej znalezionych zleceń
          </span>
          <span v-show="!refreshing && isSearchVisible && visibleTasksCount > 0 && !showAllSearchResults && foundTasksCount <= 10" class="text-success fw-bolder ms-3">
            Pokazuję wszystkie {{ visibleTasksCount }} wyników
          </span>
          <span v-show="!refreshing && isSearchVisible && showAllSearchResults" class="text-success fw-bolder ms-3">
            Pokazuję wszystkie dostępne wyniki
          </span>
          <span v-show="!refreshing && isSearchVisible && foundTasksCount === 0 && searchFinished" class="text-danger fw-bolder ms-3">
            Brak dostępnych wyników
          </span>
          <span v-show="isSearchVisible && refreshing" class="text-info fw-bold">
            Szukam...
          </span>
        </span>
        <div v-if="isSearchVisible" class="d-flex search-bar">
          <TaskFilters :date="date"/>
        </div>
      </div>
      <div>
        <button
          class="bg-white border-0"
          :class="{ 'text-primary': !refreshing, 'text-secondary': refreshing }"
          @click="init"
          :disabled="refreshing"
        >
          <i class="fas fa-sync"></i>
          <span v-if="!refreshing">
            Odśwież
          </span>
          <span v-else>
            Wczytuję...
          </span>
        </button>
      </div>
    </div>
    <div ref="tasksUtilities" id="tasks-utilities" class="row sticky-top" :style="`top: ${toolbarHeightTop}px`">
      <div class="d-lg-flex justify-content-between my-2">
        <h5 class="fw-bold mb-0 ms-1">
          ZLECENIA
        </h5>
        <div class="text-sm mx-3">
          <input
            :disabled="refreshing"
            :type="isSafari ? 'text' : 'date'"
            class="form-control"
            v-model="date"
            ref="selectedDate"
            @change="page = 1;init()"
            onfocus="this.type = 'date'"
            placeholder="dd.mm.rrrr">
        </div>
        <div>
          <TasksXlsxExport/>
        </div>
        <div>
          <button type="button" class="btn btn-success" data-bs-toggle="modal" data-bs-target="#exampleModal">
            wyświetl miesiąc
          </button>
        </div>
        <div>
          <button :disabled="refreshing || isSearchVisible" class="btn btn-primary mx-4" @click="previousPage"><i class="fa-solid fa-circle-arrow-left"></i></button>
          <button :disabled="refreshing || isSearchVisible" class="btn btn-primary mx-4" @click="nextPage"><i class="fa-solid fa-circle-arrow-right"></i></button>
        </div>
        <div>
          <Popper placement="bottom">
            <router-link to="/zlecenia/dodaj">
              <button class="btn btn-success">
                <i class="fa-solid fa-circle-plus"></i>
                Dodaj zlecenie ręcznie
              </button>
            </router-link>
          </Popper>
        </div>
        <div>
          <TasksFromCsv/>
        </div>
      </div>
    </div>
    <div class="p-1 table-responsive" style="min-width: 2500px; overflow: visible;">
      <table class="table">
        <thead id="tasks-heading" class="sticky-top bg-light" :style="`top: ${tableHeadingHeightTop}px`">
        <tr>
          <th>#</th>
          <th>
            <AllSmsesButton :tasks="tasks"/>
          </th>
          <th style="width: 200px;">Numer przejazdu</th>
          <th style="width: 200px;">Nazwa firmy</th>
          <th style="width: 200px;">Trasa</th>
          <th style="width: 320px;" role="button" @click="sortTasksByDate('zaladunek')">Załadunek <i class="fas fa-sort"></i></th>
          <th style="width: 300px;" role="button" @click="sortTasksByDate('rozladunek')">Rozładunek <i class="fas fa-sort"></i></th>
          <th>RZGZAŁ</th>
          <th>RZGROZ</th>
          <th style="width: 200px;">Ciągnik</th>
          <th style="width: 200px;">Naczepa</th>
          <th style="width: 200px;">Kierowca</th>
          <th style="width: 200px;">Stawka</th>
          <th style="width: 200px;">Waluta</th>
          <th style="width: 200px;">Spedytor</th>
          <th style="width: 200px;">FV</th>
          <th style="width: 200px;">Aplikacja</th>
          <th style="width: 200px;">Zabezpieczenie</th>
          <th style="width: 200px;">Extra cost case</th>
          <th style="width: 200px;">Opis 1</th>
          <th style="width: 200px;">Opis 2</th>
          <th style="width: 200px;">Opis 3</th>
          <th style="width: 200px;">Akcje</th>
        </tr>
        </thead>
        <tbody>
        <template v-for="(task, idx) in renderableTasks.length > 0 ? renderableTasks : tasks" :key="task.id">
          <tr
            :class="{ 'archived-task': task.archived, 'border border-5 border-success': task.numer_Przejazdu === $route.params?.vrid }"
            :style="`background-color: ${task.altBackgroundColor ?? '#ffffff'}; color: ${task.altTextColor ?? '#000000'};`"
            :id="`t${task.id}`"
            :ref="`t${task.id}`"
            v-if="!isSearchVisible || (isSearchVisible && showAllSearchResults) || (isSearchVisible && !showAllSearchResults && idx < 25)"
          >
            <td :style="`background-color: ${task.archived ? 'rgba(144, 144, 144, 0.28)' : task.altBackgroundColor ?? '#ffffff'}; color: ${task.altTextColor ?? '#000000'};`" class="fw-bolder">
              {{ task.numer_Zlecenia }}.
            </td>
            <td :style="`background-color: ${task.archived ? 'rgba(144, 144, 144, 0.28)' : task.altBackgroundColor ?? '#ffffff'}; color: ${task.altTextColor ?? '#000000'};`">
              <SmsButton :task="task" :key="task.id"/>
              <AddChange :task="task" :vehicles="vehicles"/>
            </td>
            <!-- VRID -->
            <td :style="`background-color: ${task.archived ? 'rgba(144, 144, 144, 0.28)' : task.altBackgroundColor ?? '#ffffff'}; color: ${task.altTextColor ?? '#000000'};`">
              <div class="d-inline">
                <div v-if="task.inputMode" class="d-flex">
                  <input type="text" v-model="task.numer_Przejazdu">
                  <button class="btn btn-sm btn-success" @click="updateTask(task.id, 'numer_Przejazdu', task.numer_Przejazdu);task.inputMode = false">
                    Zapisz
                  </button>
                </div>
                <div v-else>
                  {{ task.numer_Przejazdu }}
                </div>
              </div>
              <div v-show="task.inputMode">
                <button class="btn btn-sm btn-warning mt-2" @click="task.inputMode = false">
                  Zakończ edycję
                </button>
              </div>
              <Popper placement="right" v-if="!task.archived">
              <span v-show="!task.inputMode" role="button" :style="`color: ${task.altTextColor};`" class="px-2">
                <i class="fa-solid fa-pen-to-square"></i>
              </span>
                <template #content>
                  <div class="text-sm mb-2" role="button" @click="task.inputMode = !task.inputMode">Edycja zawartości</div>
                  <div class="text-sm mt-2 user-select-none">
                    Kolor komórki
                    <div class="mt-1">
                    <span
                      @click="task.altBackgroundColor = color;updateTask(task.id, 'altBackgroundColor', color)"
                      v-for="color in colors"
                      :key="color"
                      role="button"
                      class="px-1 mx-1 border border-1"
                      :style="`background-color: ${color}; color: ${color};`"
                    ></span>
                    </div>
                  </div>
                  <div class="text-sm mt-2 user-select-none">
                    Kolor czcionki
                    <div>
                    <span
                      @click="task.altTextColor = color;updateTask(task.id, 'altTextColor', color)"
                      v-for="color in colors"
                      :key="color"
                      role="button"
                      class="px-1 mx-1 border border-1"
                      :style="`background-color: ${color}; color: ${color};`"
                    ></span>
                    </div>
                  </div>
                </template>
              </Popper>
              <ChangesPreview
                :task="task"
                prop="Numer_Przejazdu"/>
            </td>
            <!-- Nazwa firmy -->
            <td :style="`background-color: ${task.archived ? 'rgba(144, 144, 144, 0.28)' : task.altBackgroundColor ?? '#ffffff'}; color: ${task.altTextColor ?? '#000000'};`"
            >
              <div v-if="task.inputMode" class="d-flex">
                <input
                  type="text"
                  v-model="task.nazna_Firmy"
                >
                <button class="btn btn-sm btn-success" @click="updateTask(task.id, 'nazna_Firmy', task.nazna_Firmy);task.inputMode = false">
                  Zapisz
                </button>
              </div>
              <div v-else>
                {{ task.nazna_Firmy }}
              </div>
              <div v-show="task.inputMode">
                <button class="btn btn-sm btn-warning mt-2" @click="task.inputMode = false">
                  Zakończ edycję
                </button>
              </div>

              <Popper placement="right">
              <span v-show="!task.inputMode" role="button" :style="`color: ${task.altTextColor};`" class="px-2">
                <span v-if="task.attachments[0]" class="text-danger fw-bolder text-decoration-underline">
                  POD
                </span>
                <span v-else class="text-primary fw-bolder text-decoration-underline">
                  POD
                </span>
              </span>
                <template #content>
                  <div v-if="task.attachments[0]">
                    <button class="btn btn-primary" @click="downloadFile(task.attachments[0].id, task)">
                      Pobierz plik
                    </button>
                    <br>
                    <button class="btn btn-danger mt-2" @click="deleteFile(task.attachments[0].id, task)">
                      usuń plik
                    </button>
                  </div>

                  <form @submit.prevent="AttachFile(task.id)" v-else>
                    <div>
                      <input type="file" :id="'file' + task.id" ref="file" class="form-control">
                    </div>
                    <button class="btn btn-primary mt-3 float-left">
                      Dodaj plik
                    </button>
                  </form>
                </template>
              </Popper>

              <Popper placement="right" v-if="!task.archived">
              <span v-show="!task.inputMode" role="button" :style="`color: ${task.altTextColor};`" class="px-2">
                <i class="fa-solid fa-pen-to-square"></i>
              </span>
                <template #content>
                  <div class="text-sm mb-2" role="button" @click="task.inputMode = !task.inputMode">Edycja zawartości</div>
                  <div class="text-sm mt-2 user-select-none">
                    Kolor komórki
                    <div class="mt-1">
                    <span
                      @click="task.altBackgroundColor = color;updateTask(task.id, 'altBackgroundColor', color)"
                      v-for="color in colors"
                      :key="color"
                      role="button"
                      class="px-1 mx-1 border border-1"
                      :style="`background-color: ${color}; color: ${color};`"
                    ></span>
                    </div>
                  </div>
                  <div class="text-sm mt-2 user-select-none">
                    Kolor czcionki
                    <div>
                    <span
                      @click="task.altTextColor = color;updateTask(task.id, 'altTextColor', color)"
                      v-for="color in colors"
                      :key="color"
                      role="button"
                      class="px-1 mx-1 border border-1"
                      :style="`background-color: ${color}; color: ${color};`"
                    ></span>
                    </div>
                  </div>
                </template>
              </Popper>
              <ChangesPreview
                :task="task"
                prop="Nazna_Firmy"/>
            </td>
            <!-- Trasa -->
            <td :style="`background-color: ${task.archived ? 'rgba(144, 144, 144, 0.28)' : task.altBackgroundColor ?? '#ffffff'}; color: ${task.altTextColor ?? '#000000'};`">
              <div :ref="`trasa${task.id}`">
                <span>{{ task.stoppages?.map(s => s.acronym)?.join(' -> ') }}</span>
              </div>
              <AttachedRoute :task="task"/>
              <ChangesPreview
                :task="task"
                prop="trasa"/>
            </td>
            <!-- Loading (załadunek) -->
            <td :style="`background-color: ${task.archived ? 'rgba(144, 144, 144, 0.28)' : task.altBackgroundColor ?? '#ffffff'}; color: ${task.altTextColor ?? '#000000'};`">
              <div>
                {{ task.zaladunek !== undefined ? moment(task.zaladunek).tz('Europe/Warsaw').format('DD.MM.YYYY HH:mm') : '' }}
              </div>
              <Popper placement="right" v-if="!task.archived">
              <span role="button" :style="`color: ${task.altTextColor};`" class="px-2">
                <i class="fa-solid fa-pen-to-square"></i>
              </span>
                <template #content>
                  <div class="text-sm mb-2" role="button" data-bs-toggle="modal" :data-bs-target="`#loadingInnerContentModal${task.id}`">Edycja daty załadunku</div>
                  <div class="text-sm mt-2 user-select-none">
                    Kolor komórki
                    <div class="mt-1">
                    <span
                      @click="task.altBackgroundColor = color;updateTask(task.id, 'altBackgroundColor', color)"
                      v-for="color in colors"
                      :key="color"
                      role="button"
                      class="px-1 mx-1 border border-1"
                      :style="`background-color: ${color}; color: ${color};`"
                    ></span>
                    </div>
                  </div>
                  <div class="text-sm mt-2 user-select-none">
                    Kolor czcionki
                    <div>
                    <span
                      @click="task.altTextColor = color;updateTask(task.id, 'altTextColor', color)"
                      v-for="color in colors"
                      :key="color"
                      role="button"
                      class="px-1 mx-1 border border-1"
                      :style="`background-color: ${color}; color: ${color};`"
                    ></span>
                    </div>
                  </div>
                </template>
              </Popper>
              <ChangesPreview
                :task="task"
                prop="Zaladunek"/>
              <!-- Modal -->
              <div class="modal fade" :id="`loadingInnerContentModal${task.id}`" tabindex="-1" aria-labelledby="loadingInnerContentModalLabel" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered">
                  <div class="modal-content">
                    <div class="modal-header">
                      <h5 class="modal-title text-black" :id="`loadingInnerContentModal${task.id}`">Edycja daty załadunku</h5>
                      <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body text-black">
                      <label class="d-block">
                        <input type="datetime-local" v-model="task.zaladunek" class="form-control">
                      </label>
                      <button
                        type="button"
                        class="btn btn-sm btn-primary mt-2"
                        data-bs-dismiss="modal"
                        @click="updateTask(task.id, 'zaladunek', task.zaladunek)"
                      >
                        Zatwierdź
                      </button>
                    </div>
                  </div>
                </div>
                <!-- / Modal -->
              </div>
            </td>
            <!-- Unloading (rozładunek) -->
            <td :style="`background-color: ${task.archived ? 'rgba(144, 144, 144, 0.28)' : task.altBackgroundColor ?? '#ffffff'}; color: ${task.altTextColor ?? '#000000'};`">
              <div>
                {{ task.rozladunek !== undefined ? moment(task.rozladunek).tz('Europe/Warsaw').format('DD.MM.YYYY HH:mm') : '' }}
              </div>
              <Popper placement="right" v-if="!task.archived">
              <span role="button" :style="`color: ${task.altTextColor};`" class="px-2">
                <i class="fa-solid fa-pen-to-square"></i>
              </span>
                <template #content>
                  <div class="text-sm mb-2" role="button" data-bs-toggle="modal" :data-bs-target="`#unloadingInnerContentModal${task.id}`">Edycja daty rozładunku</div>
                  <div class="text-sm mt-2 user-select-none">
                    Kolor komórki
                    <div class="mt-1">
                    <span
                      @click="task.altBackgroundColor = color;updateTask(task.id, 'altBackgroundColor', color)"
                      v-for="color in colors"
                      :key="color"
                      role="button"
                      class="px-1 mx-1 border border-1"
                      :style="`background-color: ${color}; color: ${color};`"
                    ></span>
                    </div>
                  </div>
                  <div class="text-sm mt-2 user-select-none">
                    Kolor czcionki
                    <div>
                    <span
                      @click="task.altTextColor = color;updateTask(task.id, 'altTextColor', color)"
                      v-for="color in colors"
                      :key="color"
                      role="button"
                      class="px-1 mx-1 border border-1"
                      :style="`background-color: ${color}; color: ${color};`"
                    ></span>
                    </div>
                  </div>
                </template>
              </Popper>
              <ChangesPreview
                :task="task"
                prop="Rozladunek"/>
              <!-- Modal -->
              <div class="modal fade" :id="`unloadingInnerContentModal${task.id}`" tabindex="-1" aria-labelledby="unloadingInnerContentModalLabel" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered">
                  <div class="modal-content">
                    <div class="modal-header">
                      <h5 class="modal-title text-black" :id="`unloadingInnerContentModal${task.id}`">Edycja daty rozładunku</h5>
                      <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body text-black">
                      <label class="d-block">
                        <input type="datetime-local" v-model="task.rozladunek" class="form-control">
                      </label>
                      <button
                        type="button"
                        class="btn btn-sm btn-primary mt-2"
                        data-bs-dismiss="modal"
                        @click="updateTask(task.id, 'rozladunek', task.rozladunek)"
                      >
                        Zatwierdź
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <!-- / Modal -->
            </td>
            <td>
              <span v-if="task.stoppages[0]?.actualArrival">
                {{ moment(task.stoppages[0].actualArrival).format('DD.MM.YYYY HH:mm') }}
              </span>
              <span v-else>
                Brak informacji
              </span>
            </td>
            <td>
              <span v-if="task.stoppages.slice(-1)[0]?.actualArrival">
                {{ moment(task.stoppages.slice(-1)[0].actualArrival).format('DD.MM.YYYY HH:mm') }}
              </span>
              <span v-else>
                Brak informacji
              </span>
            </td>
            <!-- Ciągnik -->
            <td :style="`background-color: ${task.archived ? 'rgba(144, 144, 144, 0.28)' : task.altBackgroundColor ?? '#ffffff'}; color: ${task.altTextColor ?? '#000000'};`">
              <div>
                {{ task.auto ? task.auto.plateNumber : 'Brak' }}
              </div>
              <AttachedVehicle v-if="!task.archived" :task="task"/>
              <ChangesPreview
                :task="task"
                prop="AutoId"/>
            </td>
            <!-- Naczepa -->
            <td :style="`background-color: ${task.archived ? 'rgba(144, 144, 144, 0.28)' : task.altBackgroundColor}; color: ${task.altTextColor};`">
              <div>
                <div v-if="!task.semitrailer" >
                  Brak naczep
                </div>
                <div v-else>
                  <div class="trailer-name">
                  <span>
                    {{ task.semitrailer.plateNumber }}
                  </span>
                  </div>
                </div>
              </div>
              <AttachedTrailer v-if="!task.archived" :task="task"/>
              <ChangesPreview
                :task="task"
                prop="SemiTrailerId"/>
            </td>
            <!-- Kierowcy -->
            <td :style="`background-color: ${task.archived ? 'rgba(144, 144, 144, 0.28)' : task.altBackgroundColor}; color: ${task.altTextColor};`">
              <DriversOutput :task="task"/>
              <AttachedDrivers
                v-if="drivers && !task.archived"
                :task="task"
                :drivers="drivers"
                @refresh="ReloadDrivers"
              />
              <ChangesPreview
                :task="task"
                prop="DriversId"/>
            </td>
            <!-- Stawka -->
            <td :style="`background-color: ${task.archived ? 'rgba(144, 144, 144, 0.28)' : task.altBackgroundColor}; color: ${task.altTextColor};`">
              <div v-if="task.inputMode" class="d-flex">
                <input type="text" v-model="task.stawka">
                <button class="btn btn-sm btn-success" @click="updateTask(task.id, 'stawka', task.stawka);task.inputMode = false">
                  Zapisz
                </button>
              </div>
              <div v-else>
                {{ task.stawka.toString().replace('.', ',') }}
              </div>
              <div v-show="task.inputMode">
                <button class="btn btn-sm btn-warning mt-2" @click="task.inputMode = false">
                  Zakończ edycję
                </button>
              </div>
              <Popper placement="right" v-if="!task.archived">
              <span v-show="!task.inputMode" role="button" :style="`color: ${task.altTextColor};`" class="px-2">
                <i class="fa-solid fa-pen-to-square"></i>
              </span>
                <template #content>
                  <div class="text-sm mb-2" role="button" @click="task.inputMode = !task.inputMode">Edycja zawartości</div>
                  <div class="text-sm mt-2 user-select-none">
                    Kolor komórki
                    <div class="mt-1">
                    <span
                      @click="task.altBackgroundColor = color;updateTask(task.id, 'altBackgroundColor', color)"
                      v-for="color in colors"
                      :key="color"
                      role="button"
                      class="px-1 mx-1 border border-1"
                      :style="`background-color: ${color}; color: ${color};`"
                    ></span>
                    </div>
                  </div>
                  <div class="text-sm mt-2 user-select-none">
                    Kolor czcionki
                    <div>
                    <span
                      @click="task.altTextColor = color;updateTask(task.id, 'altTextColor', color)"
                      v-for="color in colors"
                      :key="color"
                      role="button"
                      class="px-1 mx-1 border border-1"
                      :style="`background-color: ${color}; color: ${color};`"
                    ></span>
                    </div>
                  </div>
                </template>
              </Popper>
              <ChangesPreview
                :task="task"
                prop="stawka"/>
            </td>
            <!-- Waluta -->
            <td :style="`background-color: ${task.archived ? 'rgba(144, 144, 144, 0.28)' : task.altBackgroundColor}; color: ${task.altTextColor};`">
              <div>
                {{ task.waluta ?? this.actualCurrency }}
              </div>
              <Popper placement="right">
                <button style="border: none; background: none;"><i class="fa-solid fa-pen-to-square px-2"></i></button>
                <template #content>
                  <h5>Edycja waluty</h5>
                  <input type="text" v-model="currencyInput">
                  <button @click="this.updateTask(task.id, 'waluta', currencyInput)">Edytuj</button>
                </template>
              </Popper>
              <ChangesPreview
                :task="task"
                prop="waluta"/>
            </td>
            <td role="button" :style="`background-color: ${task.archived ? 'rgba(144, 144, 144, 0.28)' : task.altBackgroundColor}; color: ${task.altTextColor};`">
              <popper placement="right">
                <div v-if="task.freightForwarder">{{ task.freightForwarder }}</div> <div v-else>{{ 'brak' }}</div>
                <template #content>
                  <span v-html="task.freightForwarder">  </span>
                  <br>
                  <span class="btn btn-primary" @click="editAdditionalInfo('freightForwarder', task)" role="button"> Edytuj </span>
                </template>
              </popper>
            </td>
            <td role="button" :style="`background-color: ${task.archived ? 'rgba(144, 144, 144, 0.28)' : task.altBackgroundColor}; color: ${task.altTextColor};`">
              <popper placement="right">
                <div v-if="task.fv">{{ task.fv }}</div> <div v-else>{{ 'brak' }}</div>
                <template #content>
                  <span v-html="task.fv">  </span>
                  <br>
                  <span @click="editAdditionalInfo('fv', task)" class="btn btn-primary" role="button"> Edytuj </span>
                </template>
              </popper>
            </td>
            <td role="button" :style="`background-color: ${task.archived ? 'rgba(144, 144, 144, 0.28)' : task.altBackgroundColor}; color: ${task.altTextColor};`">
              <popper placement="right">
                <div v-if="task.application">{{ task.application }}</div> <div v-else>{{ 'brak' }}</div>
                <template #content>
                  <span v-html="task.application">  </span>
                  <br>
                  <span @click="editAdditionalInfo('application', task)" class="btn btn-primary" role="button"> Edytuj </span>
                </template>
              </popper>
            </td>
            <td role="button" :style="`background-color: ${task.archived ? 'rgba(144, 144, 144, 0.28)' : task.altBackgroundColor}; color: ${task.altTextColor};`">
              <popper placement="right">
                <div v-if="task.security">{{ task.security }}</div> <div v-else>{{ 'brak' }}</div>
                <template #content>
                  <span v-html="task.security">  </span>
                  <br>
                  <span @click="editAdditionalInfo('security', task)" class="btn btn-primary" role="button"> Edytuj </span>
                </template>
              </popper>
            </td>
            <td role="button" :style="`background-color: ${task.archived ? 'rgba(144, 144, 144, 0.28)' : task.altBackgroundColor}; color: ${task.altTextColor};`">
              <popper placement="right">
                <div v-if="task.extraCostCase">{{ task.extraCostCase }}</div> <div v-else>{{ 'brak' }}</div>
                <template #content>
                  <span v-html="task.extraCostCase">  </span>
                  <br>
                  <span @click="editAdditionalInfo('extraCostCase', task)" class="btn btn-primary" role="button"> Edytuj </span>
                </template>
              </popper>
            </td>
            <td role="button" :style="`background-color: ${task.archived ? 'rgba(144, 144, 144, 0.28)' : task.altBackgroundColor}; color: ${task.altTextColor};`">
              <popper placement="right">
                <div v-if="task.description1">{{ task.description1 }}</div> <div v-else>{{ 'brak' }}</div>
                <template #content>
                  <span v-html="task.description1">  </span>
                  <br>
                  <span @click="editAdditionalInfo('description1', task)" class="btn btn-primary" role="button"> Edytuj </span>
                </template>
              </popper>
            </td>
            <td role="button" :style="`background-color: ${task.archived ? 'rgba(144, 144, 144, 0.28)' : task.altBackgroundColor}; color: ${task.altTextColor};`">
              <popper placement="right">
                <div v-if="task.description2">{{ task.description2 }}</div> <div v-else>{{ 'brak' }}</div>
                <template #content>
                  <span v-html="task.description2">  </span>
                  <br>
                  <span @click="editAdditionalInfo('description2', task)" class="btn btn-primary" role="button"> Edytuj </span>
                </template>
              </popper>
            </td>

            <td role="button" :style="`background-color: ${task.archived ? 'rgba(144, 144, 144, 0.28)' : task.altBackgroundColor}; color: ${task.altTextColor};`">
              <popper placement="right">
                <div v-if="task.description3">{{ task.description3 }}</div> <div v-else>{{ 'brak' }}</div>
                <template #content>
                  <span v-html="task.description3">  </span>
                  <br>
                  <span @click="editAdditionalInfo('description3', task)" class="btn btn-primary" role="button"> Edytuj </span>
                </template>
              </popper>
            </td>
            <td>
              <TaskActions :task="task"/>
            </td>
          </tr>
          <ChangeListing :task="task" colspan="23"/>
          <ChangeReference :given-task="task" :export-month="false"/>
        </template>
        <div v-observe-visibility="handleScrolledToBottom"></div>
        </tbody>
      </table>
    </div>
    <div v-show="tasksLoading && !isSearchVisible" class="text-primary fw-bold mt-2 text-center">
      Wczytuję zlecenia...
    </div>
    <div v-show="foundTasksCount > 0" class="text-primary fw-bold mt-2 text-center">
      Łącznie {{ foundTasksCount }} znalezionych zleceń
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import Navbar from '@/components/Navbar'
import Popper from 'vue3-popper'
import Swal from 'sweetalert2'
import ChangesPreview from '@/components/ChangesPreview'
import AttachedVehicle from '@/components/AttachedVehicle'
import AttachedDrivers from '@/components/AttachedDrivers'
import DriversOutput from '@/components/DriversOutput'
import AttachedRoute from '@/components/AttachedRoute'
import AttachedTrailer from '@/components/AttachedTrailer.vue'
import emitter from '@/modules/events/emitter'
import colors from '@/modules/cells/colors'
import AddChange from '@/components/addChange'
import { updateTaskLoadingDate, updateTaskUnloadingDate } from '@/modules/task/updateService'
import { mapActions, mapGetters } from 'vuex'
import SmsButton from '@/components/Partials/SmsNotifications/SmsButton.vue'
import eventKinds from '@/modules/events/eventKinds'
import ChangeReference from '@/components/Partials/Changes/VehicleChange/ChangeReference.vue'
import ChangeListing from '@/components/Partials/Changes/VehicleChange/ChangeListing.vue'
import AllSmsesButton from '@/components/Partials/SmsNotifications/AllSmsesButton.vue'
import TasksXlsxExport from '@/components/TasksList/TasksXlsxExport.vue'
import TaskActions from '@/components/TasksList/TaskActions.vue'
import { $axios } from '@/modules/http/axios'
import moment from 'moment-timezone'
import CopyTaskModal from '@/components/TasksList/Modals/CopyTaskModal.vue'
import TasksFromCsv from '@/components/TasksList/Import/TasksFromCsv.vue'
import TaskFilters from '@/components/TasksList/TaskFilters.vue'
import SelectMonthModal from '@/components/TasksList/Modals/SelectMonthModal.vue'

export default {
  name: 'TasksList',
  components: { SelectMonthModal, TaskFilters, TasksFromCsv, CopyTaskModal, TaskActions, TasksXlsxExport, AllSmsesButton, ChangeListing, ChangeReference, SmsButton, AttachedRoute, AttachedTrailer, DriversOutput, AttachedDrivers, AttachedVehicle, ChangesPreview, Navbar, Popper, AddChange },
  data () {
    return {
      isSafari: /^((?!chrome|android).)*safari/i.test(navigator.userAgent),
      axiosConfig: { headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` } },
      isAscOrdering: true,
      isSearchVisible: false,
      searchText: '',
      task: null,
      tasks: [],
      date: null,
      monthlyDate: null,
      yearChoose: null,
      scrollerDay: 1,
      colors: colors,
      perPage: 8,
      page: 1,
      key: '',
      key1: 'EUR',
      actualCurrency: 'EUR',
      OnOffMeter: 1,
      months: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
      appendTaskDate: 0,
      skipTasks:0,
      currencyInput:'',
      tasksLoading: false,
      refreshing: false,
      foundTasksCount: 0,
      visibleTasksCount: 0,
      controller: new AbortController(),
      weekSelect:'',
      weeksList: [],
      toolbarHeightTop: 0,
      tableHeadingHeightTop: 0,
      showAllSearchResults: false,
      searchFinished: false
    }
  },
  created () {
    this.$store.commit('setInitialCalendarLoading', true)
    this.$store.dispatch('fetchDrivers')
    this.date = new Date().toISOString().split('T')[0]
    this.init()

    emitter.on(eventKinds.calendarShown, () => {
      this.controller.abort()
    })
    emitter.on(eventKinds.storehouseShown, () => {
      this.controller.abort()
    })
    emitter.on(eventKinds.driverListingShown, () => {
      this.controller.abort()
    })
    emitter.on(eventKinds.placesShown, () => {
      this.controller.abort()
    })
    emitter.on(eventKinds.reportsShown, () => {
      this.controller.abort()
    })
    emitter.on(eventKinds.usersShown, () => {
      this.controller.abort()
    })
    emitter.on(eventKinds.taskCopied, this.init)
    emitter.on('taskChanged', e => {
      const config = { headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` } }
      this.tasks.map(async (taskFromCollection, index) => {
        if (taskFromCollection.id === e.taskId) {
          const fetchTask = (await axios.get(`${process.env.VUE_APP_API_BASE_URL}Task/${e.taskId}`, config)).data
          this.tasks[index] = fetchTask
          this.$store.commit('setPlanningTask', fetchTask)
        }
      })
    })
    emitter.on(eventKinds.planningSearchClosed, this.init)
    window.addEventListener('scroll', this.scrollFunction)
  },
  mounted () {
    this.toolbarHeightTop = 57.5 + this.$refs.toolbar.clientHeight
    this.tableHeadingHeightTop = this.toolbarHeightTop + this.$refs.tasksUtilities.clientHeight
  },
  computed: {
    ...mapGetters({
      monthlyTasks   : 'getMonthlyTasks',
      searchableTasks: 'getPlanningTasks',
      renderableTasks: 'getRenderableTasks',
      vehicles       : 'getVehicles',
      drivers        : 'getDrivers',
      delayReports   : 'getDelayReports'
    })
  },
  methods: {
    ...mapActions({
      fetchDelayReports: 'fetchDelayReports'
    }),
    moment,
    init () {
      this.toolbarHeightTop = 83
      this.tableHeadingHeightTop = 136
      this.showAllSearchResults = false
      this.searchFinished = false
      this.foundTasksCount = 0
      this.visibleTasksCount = 0

      if (this.$route.params?.vrid && this.$route.params?.date) {
        this.date = this.$route.params.date
        this.isSearchVisible = true
      } else {
        this.refreshing = true
        this.searchText = ''
        this.isSearchVisible = false
        this.tasks = []
        this.foundTasksCount = 0
        this.skipTasks = 0
        this.appendTaskDate = 0

        this.appendTasksOnDemand().then(() => this.appendTasksOnDemand()).then(() => this.appendTasksOnDemand())
      }
    },
    ReloadDrivers () {
      this.init()
    },
    handleScrolledToBottom (isVisible) {
      if (!isVisible || this.refreshing || this.monthlyDate) { return }
      this.appendTasksOnDemand()
    },

    async appendTasksOnDemand () {
      if (this.isSearchVisible) {
        return;
      }

      const sortOrder = this.isAscOrdering ? 0 : 1

      const skip = this.skipTasks
      const take = this.perPage

      const today = new Date(this.date)
      const tomorrow = new Date(today)
      tomorrow.setDate(tomorrow.getDate() + this.appendTaskDate)

      const loadingDate = `${String(tomorrow).split(' ')[3]}-${this.months.indexOf(String(tomorrow).split(' ')[1])+1}-${String(tomorrow).split(' ')[2]}`
      let requestUriParams = `?sortOrder=${sortOrder}&skip=${skip}&take=${take}`

      requestUriParams += `&loadingDate=${loadingDate}`

      try {
        this.tasksLoading = this.refreshing = true
        const newTasks = (await axios.get(`${process.env.VUE_APP_API_BASE_URL}Task/Filtered/Pagination${requestUriParams}`, this.axiosConfig)).data

        if (newTasks.length < this.perPage) {
          this.appendTaskDate++
          this.skipTasks = 0
        } else {
          this.skipTasks += newTasks.length
        }

        if (this.tasks[this.tasks.length - 1]?.id === newTasks[0]?.id) {
          newTasks.shift()
        }

        this.tasks = this.tasks.concat(newTasks)
      } catch (e) {
        console.log(e)
      } finally {
        this.tasksLoading = this.refreshing = false
      }
    },
    async updateTask (id, key, value) {
      const task = (await $axios.get(`Task/${id}`)).data
      let stoppages = []

      if (key === 'zaladunek') {
        stoppages = updateTaskLoadingDate(task, value)
      }

      if (key === 'rozladunek') {
        stoppages = updateTaskUnloadingDate(task, value)
      }

      task[key] = value

      if (key === 'stawka') {
        task[key] = value.toString().replace(',', '.')
      }

      const putData = {
        textColor: task.textColor,
        backgroundColor: task.backgroundColor,
        altTextColor: task.altTextColor,
        altBackgroundColor: task.altBackgroundColor,
        numer_Przejazdu: task.numer_Przejazdu,
        nazwa_Firmy: task.nazna_Firmy,
        przewoznik: task.nazna_Firmy,
        linia: task.trasa,
        zaladunek: task.zaladunek,
        rozladunek: task.rozladunek,
        szacunkowy_Koszt: task.stawka,
        waluta: task.waluta
      }

      if (stoppages.length > 0) {
        putData.postoje = stoppages
      }

      try {
        await $axios.put(`Task/${id}`, putData)

        // if (key === 'zaladunek' || key === 'rozladunek') {
        //   this.init()
        // } else {
          emitter.emit('taskChanged', { taskId: id })
        //}
      } catch (e) {
        await Swal.fire('Nie udało się zaktualizować tabeli', '', 'error')
      }
    },
    sortTasksByDate (dateProperty, withOrderingChange = true) {
      if (withOrderingChange) {
        this.isAscOrdering = !this.isAscOrdering
      }

      this.tasks = this.tasks.sort((a, b) => {
        const aDate = new Date(a[dateProperty])
        const bDate = new Date(b[dateProperty])
        if (this.isAscOrdering) {
          return aDate - bDate
        } else {
          return bDate - aDate
        }
      })
    },
    scrollFunction () {
      if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
        if (this.$refs.mybutton !== null) {
          this.$refs.mybutton.style.display = 'block'
        }
      } else {
        if (this.$refs.mybutton !== null) {
          this.$refs.mybutton.style.display = 'none'
        }
      }
    },
    backToTop () {
      document.body.scrollTop = 0
      document.documentElement.scrollTop = 0
    },
    nextPage () {
      this.controller.abort()
      this.tasks = []
      const date = new Date(this.date)
      date.setDate(date.getDate() + 1)

      this.appendTaskDate = 0
      this.page = 1
      this.date = date.toISOString().split('T')[0]
      this.skipTasks = 0

      this.appendTasksOnDemand().then(() => this.appendTasksOnDemand()).then(() => this.appendTasksOnDemand())
    },
    previousPage () {
      this.controller.abort()
      this.tasks = []
      const date = new Date(this.date)
      date.setDate(date.getDate() - 1)

      this.appendTaskDate = 0
      this.page = 1
      this.date = date.toISOString().split('T')[0]
      this.skipTasks = 0

      this.appendTasksOnDemand().then(() => this.appendTasksOnDemand()).then(() => this.appendTasksOnDemand())
    },
    AttachFile (id) {
      const config = {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${localStorage.getItem('accessToken')}`
        }
      }

      const file = document.getElementById('file' + id).files[0]
      const formData = new FormData()
      formData.append('file', file)

      axios.post(`${process.env.VUE_APP_API_BASE_URL}Task/${id}/Attachment`, formData, config)
        .then(response => {
          Swal.fire('Sukces', 'Pomyślnie przesłano plik', 'success')
          emitter.emit('taskChanged', { taskId: id })
        })
        .catch(err => {
          Swal.fire('Błąd', 'coś poszło nie tak', 'error')
          console.log(err)
        })
    },
    downloadFile (id, task) {
      $axios.get(`Task/Attachment/${id}`, { responseType: 'blob' })
        .then(response => {
          const url = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')
          link.href = url
          const fileName = `${task.numer_Przejazdu}_${task.nazna_Firmy}_${task.rozladunek}`

          let extension = response.headers['content-type'].split('/')[1]

          if (extension === 'msword') {
            extension = 'doc'
          } else if (extension === 'plain') {
            extension = 'txt'
          } else if (extension === 'vnd.openxmlformats-officedocument.wordprocessingml.document') {
            extension = 'docx'
          }

          link.setAttribute('download', `${fileName}.${extension}`)
          document.body.appendChild(link)
          link.click()
        })
    },
    deleteFile (id, task) {
      const config = { headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` } }
      axios.delete(`${process.env.VUE_APP_API_BASE_URL}Task/Attachment/${id}`, config)
        .then(response => {
          Swal.fire('Sukces', 'Pomyślnie usunięto plik', 'success')
          emitter.emit('taskChanged', { taskId: task.id })
        })
    },
    async editAdditionalInfo (field, task) {
      const config = { headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` } }
      let value = ''
      if (task[field] == null) {
        value = ''
      } else {
        value = task[field].replaceAll('<br>', '\n')
      }

      // eslint-disable-next-line no-unused-vars
      const { value: ipAddress } = await Swal.fire({
        title: 'Aktualizuj pole',
        input: 'textarea',
        inputLabel: 'Aktualizuj pole',
        // eslint-disable-next-line no-undef
        inputValue: value,
        showCancelButton: true,
        inputValidator: (value) => {
          if (!value) {
            return 'Musisz coś napisać!'
          } else {
            task[field] = value.replace(/(?:\r\n|\r|\n)/g, '<br>')

            const putData = { [field]: task[field] }

            axios.put(`${process.env.VUE_APP_API_BASE_URL}Task/${task.id}`, putData, config)
              .then(() => {

              })
          }
        }
      })
    }
  }
}
</script>

<style>
  .popup{
    position: fixed;
    width: 100%;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.308);
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .box{
    width: 200px;
    height: auto;
    background-color: white;
    border-radius: 15px;
    padding: 50px 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .loading-box{
    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    width: 100%;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.205);
  }
  .loader {
  border: 16px solid #f3f3f3;
  border-radius: 50%;
  border-top: 16px solid #3f3f3f;
  width: 120px;
  height: 120px;
  -webkit-animation: spin 2s linear infinite; /* Safari */
  animation: spin 2s linear infinite;
}

/* Safari */
@-webkit-keyframes spin {
  0% { -webkit-transform: rotate(0deg); }
  100% { -webkit-transform: rotate(360deg); }
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.trailer-name {
  font-size: 12px;
  font-weight: 300;
  margin-bottom: 3px;
}

.swal-wide-container {
  width: 64em !important;
}

.swal2-container {
  z-index: 3000000 !important;
}

.swal2-textarea {
  height: auto !important;
}

.driverName:hover{
  text-decoration: line-through;
}
.colDirec{
  display: flex;
  flex-direction: column;
}

.colDirec > input{
  margin-top: 5px;
}
tr[id *= 't']{
  position: relative;
}
.chPanel > div{
  height: 32px;
  margin: 0;
  padding: 0;
  width: 100%;
  display:flex;
  justify-content: flex-start;
}

.archived-task {
  background-color: rgba(144, 144, 144, 0.28);
  cursor: not-allowed;
}

#toolbar {
  background: white;
}

#tasks-utilities {
  background-color: white;
}

#tasks-utilities button {
  font-size: 0.9rem;
}

#tasks-utilities input {
  font-size: 0.9rem;
}

.search-bar {
  width: 610px;
}

.modal {
  z-index: 100000 !important;
}
</style>
